module.exports = __webpack_public_path__ + "static/media/Modern SHR Guitar Match off VR.f1ecf19.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/Modern SHR Guitar Match off VR.mp3
// module id = CV07
// module chunks = 12